import React from 'react';
import PropTypes from 'prop-types';
import { SelectStudentIcon, AllAssigned } from '@helpers/icon-dictionary';
import { MAX_STUDENT_GRADE_LENGTH, MAX_STUDENT_NAME_LENGTH_CONTEXT } from '@helpers/constants';

import SvgIcon from '@components/svg-icon/svg-icon';

import getTranslations from '../../translations';
import { truncateStringEllipsis } from '../../helpers';

import { List, ListItemTitle, ListItem, Link, Icon } from './styled';

const ContextModalContent = props => {
  const {
    classroomName,
    groupName,
    i18n,
    onClickCurrentAssignmentModalCallback,
    onClickStudentCallback,
    studentFullName
  } = props;

  /**
   * Translations
   */
  const { CLASS_TEXT, SELECT_STUDENT_TEXT, GROUP_TEXT, CURRENT_ASSIGNMENTS_TEXT } = getTranslations({ i18n });

  return (
    <div data-testid="student-context-modal-content">
      <List>
        <ListItemTitle>{truncateStringEllipsis(studentFullName, MAX_STUDENT_NAME_LENGTH_CONTEXT)}</ListItemTitle>
        <ListItem>{`${CLASS_TEXT}: ${truncateStringEllipsis(classroomName, MAX_STUDENT_GRADE_LENGTH)}`}</ListItem>
        <ListItem>{`${GROUP_TEXT}: ${truncateStringEllipsis(groupName, MAX_STUDENT_GRADE_LENGTH)}`}</ListItem>
      </List>
      <List>
        <Link data-testid="student-context-modal-select-student" onClick={onClickStudentCallback}>
          <Icon>
            <SvgIcon icon={SelectStudentIcon} />
          </Icon>
          {SELECT_STUDENT_TEXT}
        </Link>

        <Link
          data-testid="student-context-modal-select-current-assignment"
          onClick={onClickCurrentAssignmentModalCallback}
        >
          <Icon>
            <SvgIcon icon={AllAssigned} />
          </Icon>
          {CURRENT_ASSIGNMENTS_TEXT}
        </Link>
      </List>
    </div>
  );
};

ContextModalContent.propTypes = {
  classroomName: PropTypes.string.isRequired,
  groupName: PropTypes.string.isRequired,
  i18n: PropTypes.object,
  onClickCurrentAssignmentModalCallback: PropTypes.func.isRequired,
  onClickStudentCallback: PropTypes.func.isRequired,
  studentFullName: PropTypes.string.isRequired
};

export default ContextModalContent;
